import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '@api/custom-services/user.service';
import { Role } from '@shared/constants/role';
import { SubscriptionDirective } from '@shared/directives/subscriptions.directive';

@Component({
   selector: 'app-redirect',
   imports: [CommonModule],
   template: 'Redirecting...',
})
export class RedirectComponent extends SubscriptionDirective {
   constructor(
      private userService: UserService,
      private router: Router
   ) {
      super();
      this.redirect();
   }

   redirect() {
      this.subs = this.userService.user$.subscribe((user) => {
         if (user.roleName === Role.PROMOTER) {
            this.router.navigateByUrl('/promoter/ticket').then();
         } else {
            this.router.navigateByUrl('/statistics').then();
         }
      });
   }
}
